import React, { Fragment, useRef } from 'react'
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import BrandMasterEditable from './BrandMasterEditable';
import BrandMasterReadOnly from './BrandMasterReadOnly';
import { useEffect } from 'react';
import * as XLSX from 'xlsx'
import Popup from 'reactjs-popup';
import PopupTable from '../../PopupTable';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import ExcelDownload from '../../../data/exceldownload';
import { useAddBulkbrandmasterMutation, useAddNewbrandmasterMutation, useDeletebrandmasterMutation, useGetbrandmasterQuery, useUpdatebrandmasterMutation } from '../../../features/brandmaster/brandmasterApiSlice';
import { useGetAssetMastersQuery } from '../../../features/assetmasterApiSlice/assetmasterApiSlice';
import { Autocomplete, Checkbox } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';





const BRAND_REGEX = /^[a-zA-Z0-9\s\-_&.]+$/;

const Addcategform = styled.form`
  display: flex;
  margin:10px;
`
const Displaydiv1 = styled.div`

`

const FormEleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items:center;
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`

const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`
const CustomFileUploadButton = styled.label`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`
const BulkWrapper = styled.div`
  display: flex;
  align-items:center;
`

const InputFile = styled.input`
  width: 180px;
  display: none;
`

const SelectFileReset = styled.button`
  margin-right: 10px;
`
const ComplaintCategoryWrapper =styled.div`
  display: flex;
  align-items: center;
  justify-content:space-between;

`

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const tableFontSize = 18;

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function CustomPaginationActionsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const {brandmaster} = useGetbrandmasterQuery("brandmasterList", {
    selectFromResult: ({ data }) => ({
      brandmaster: data?.entities
    }),
  })
  
  const {assetmasters} = useGetAssetMastersQuery("assetmasters", {
    selectFromResult: ({ data }) => ({
      assetmasters: data?.entities
    }),
  })
  
  const [addNewBrandMaster] = useAddNewbrandmasterMutation();
  const [addBulkBrandMaster] = useAddBulkbrandmasterMutation();
  const [updateBrandMaster] = useUpdatebrandmasterMutation();
  const [deleteBrandMaster] = useDeletebrandmasterMutation();


  const inputFile = useRef(null);
  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({});
  const [addBrandMasterData, setAddBrandMasterData] = useState({});
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [duplicateValues, setDuplicateValues] = useState();
  const [invalidValues, setInvalidValues] = useState();
  const [finalFile, setFinalFile] = useState([]);
  const [downloadData, setDownloadData] = useState({});
  const [bulkDataAdded, setBulkDataAdded] = useState(false);
  const [sentData, setSentData ]= useState(0);
  const [fileName, setFileName] = useState("");
  const [subject, setSubject] = useState({
    subjectValue: [...Array(tabledata.length).fill("")],
    subjectIndex: ""
  });
  const [validBrandId, setValidBrandId] = useState(false);
  const [brandIDFocus, setBrandIdFocus] = useState(false);

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmit = async (event) =>{
    event.preventDefault();
    console.log(addBrandMasterData)
    try{
      let bodyobject = {
        "name": addBrandMasterData.name.trim(),
        "applicableCategory": addBrandMasterData.applicableCategory || []
      };
      const found = Object.values(brandmaster).some(el => el.name === addBrandMasterData.name);
   if(!found && addBrandMasterData?.name?.length ){
      const res = await addNewBrandMaster(bodyobject) ;
      alert(`New Brand ${bodyobject.name} added in masters.`)
      setAddBrandMasterData({});
      setSentData(sentData+1);
      }
    } catch(err){console.log(err)}
    setAddBrandMasterData({})
  }

  const onClickEdit = (e,k,row)=>{

    if((subject.subjectValue[k] === "") ||(subject.subjectValue[k] === undefined)){
      const temp = {...subject}
      temp.subjectIndex ="";
      setSubject(temp);
    }
    setEditCategory(k+1);

  }

  const onChangeAddBrandMaster = (event, newValue, name) =>{
    console.log(event.target.value)
    let temp ={...addBrandMasterData}
    if (event.target.name === "name") {
      temp = {...temp, [event.target.name]: event.target.value}
    }
    if (name === "applicableCategory") {
      temp = {...temp, [name]: newValue}
    }
    setAddBrandMasterData(temp);
  }

  const onChangeEditBrand = (event, newValue, name) =>{
    let temp ={...editFormData}    
    if (event.target.name && event.target.name.startsWith('brandmaster')) {
      temp = {...temp, [event.target.name]: event.target.value}
    }
    if (name && name.startsWith('applicableCategory')) {
      temp = {...temp, [name]: newValue}
    }
    setEditFormData(temp);
  }

  const handleButtonClick = () => {
    inputFile.current.click();
  }; 

  const handleEditFormSubmit = async (e) =>{
    e.preventDefault();
    try{
    setEditCategory(null);
    const id = tabledata[((page)*(rowsPerPage))+(editCategory-1)].id;
    let body ={}
    if (editFormData[`brandmaster${editCategory-1}`] !== undefined){ 
    body = {
      ...body,
      "id": id, 
      "name": editFormData[`brandmaster${((page)*(rowsPerPage))+(editCategory-1)}`].trim(),
      "applicableCategory": editFormData[`applicableCategory${editCategory-1}`] || []
    }
    }
    const response = await updateBrandMaster(body)
    setSentData(body);
    }catch(err){}
  }  

  const handleCancelClick = (e,k) => {    
    const tempObject = {...subject};
    tempObject.subjectValue[k] = "";
    setEditCategory(null);
    setSubject(tempObject);
  };

  const handleDeleteClick = async (e,k,row) => {
    e.preventDefault();
    let body = {"id":row.id}
    const response = window.confirm(`Do you want to delete Brand "${row.name}"` )
    if(!response) return;
    alert(`Brand "${row.name}" deleted successfully`);
    const result = await deleteBrandMaster(body);
  };

  const assignFunction = (data) => {
    setFile(data);
    let reducedArray = [];
    let invalidValues = [];
    const tempArray = [...data];
    for(let val of tempArray){
      let tempObj = {
        name: val.name,
        applicableCategory: val.applicableCategory ? 
          (typeof val.applicableCategory === 'string' ? 
            val.applicableCategory.split(',').map(cat => cat.trim()).filter(cat => cat) : 
            val.applicableCategory) : 
          []
      }
      if(BRAND_REGEX.test(val.name)){
        reducedArray.push(tempObj)
      }else{
        invalidValues.push(tempObj)
      }
    }
    setInvalidValues(invalidValues);
    const nameArray = Object.values(brandmaster).map(item => item.name);
    setDuplicateValues(reducedArray.filter(item => nameArray.includes(item.name)));   
    
    // Ensure finalFile is always an array
    const validBrands = reducedArray.filter(item => !nameArray.includes(item.name));
    setFinalFile(validBrands);
    
    console.log("Processed brands:", {
      original: data,
      reduced: reducedArray,
      valid: validBrands,
      finalFile: validBrands
    });
  }

  const onBulkSubmit = async (e) =>{
    e.preventDefault();   
    
    // Check if there's data to submit
    if (!finalFile || finalFile.length === 0) {
      alert("No valid brands to upload. Please check your file and try again.");
      return;
    }
    
    console.log("Submitting bulk brands:", finalFile);
    console.log("finalFile type:", typeof finalFile);
    console.log("finalFile isArray:", Array.isArray(finalFile));
    console.log("finalFile length:", finalFile.length);
    
    // Ensure finalFile is an array
    const brandsToUpload = Array.isArray(finalFile) ? finalFile : Object.values(finalFile);
    console.log("Brands to upload:", brandsToUpload);
    
    try {
      const result = await addBulkBrandMaster(brandsToUpload);
      console.log("Bulk upload result:", result);
      
      // Check if the result exists and has the expected structure
      if (result && result.data) {
        if (result.data.acknowledged) {
          setBulkDataAdded(true);
          alert(`Bulk brands added successfully! ${result.data.insertedCount || brandsToUpload.length} brands were uploaded.`);
          // Refresh the data
          window.location.reload();
        } else if (result.data.insertedIds || result.data.insertedCount) {
          // Alternative success indicators
          setBulkDataAdded(true);
          alert(`Bulk brands added successfully! ${result.data.insertedCount || brandsToUpload.length} brands were uploaded.`);
          // Refresh the data
          window.location.reload();
        } else {
          // Handle other response formats
          setBulkDataAdded(true);
          alert(`Bulk brands processed successfully! ${brandsToUpload.length} brands were uploaded.`);
          // Refresh the data
          window.location.reload();
        }
      } else if (result && result.error) {
        // Handle error response
        console.error("API Error:", result.error);
        alert(`Error: ${result.error.message || 'Failed to add bulk brands'}`);
      } else {
        // Handle unexpected response format
        console.warn("Unexpected response format:", result);
        setBulkDataAdded(true);
        alert(`Bulk brands processed successfully! ${brandsToUpload.length} brands were uploaded.`);
        // Refresh the data
        window.location.reload();
      }
    } catch (error) {
      console.error("Bulk upload error:", error);
      console.error("Error details:", {
        message: error.message,
        status: error.status,
        data: error.data,
        stack: error.stack
      });
      
      if (error.status === 401) {
        alert("Authentication failed. Please log in again.");
      } else if (error.status === 403) {
        alert("Access denied. You don't have permission to perform this action.");
      } else if (error.status === 500) {
        alert("Server error. Please try again later.");
      } else {
        alert(`Error occurred: ${error.message || 'Failed to add bulk brands. Please check the console for details.'}`);
      }
    }
  }

  const deleteSelectFile = () => {
    if(inputFile.current){
      inputFile.current.value = "";
      inputFile.current.type = "text"; 
      inputFile.current.type = "file";
      setFile(null)
    }
  }

  const fileType = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]
  const handleChangeBrand = (e) => {
    let selectedFile = e.target.files[0]
    if(selectedFile){
      if(fileType.includes(selectedFile.type)){
        setFileName(selectedFile.name)
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile)
        reader.onload = (e) => {
          setFileError(null);
          const workbook = XLSX.read(e.target.result, {type:'buffer' });
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          const data = XLSX.utils.sheet_to_json(worksheet);
          assignFunction(data);
        }
      }else{
        setFileError("Please Select Correct File Type")
        setFile(null)
      }
    }else{
      setFileError("no file selected")
      setFile(null) 
    }
  } 

  useEffect(()=>{
    if(brandmaster){
      const brandmasterArray = Object.values(brandmaster);
      setTabledata(brandmasterArray);
      let temp = {...editFormData};
      for(let i=0;i< brandmasterArray.length;i++){
        temp = {...temp, [`brandmaster${i}`]:brandmasterArray[i].name}
        temp = {...temp, [`applicableCategory${i}`]:brandmasterArray[i].applicableCategory || []}
      }
      setEditFormData(temp);
    }
  },[brandmaster])

  useEffect(() => {
    setValidBrandId(BRAND_REGEX.test(addBrandMasterData.name));        
  }, [addBrandMasterData.name])

//Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["name", "applicableCategory"]
  let tempDownloadData = structuredClone(tabledata);
  for(let val of tempDownloadData ){
      let {_id, ...others} = val;
      others = {...others, ["name"]: val.name, ["applicableCategory"]: Array.isArray(val.applicableCategory) ? val.applicableCategory.join(", ") : "" }
      finalDownloadData.push(others)
    }
    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
}, [tabledata])

// Template data for Excel upload format
const templateData = [
  { name: "Samsung", applicableCategory: "Electronics, Mobile Phones" },
  { name: "Apple", applicableCategory: "Electronics, Computers, Mobile Phones" },
  { name: "Dell", applicableCategory: "Computers, Laptops" },
];
 
   
  return (
    <>
   
    <Displaydiv1>
      <HeadingWrap>
        <Span>Add New Brand Id</Span>
      </HeadingWrap>

    <ComplaintCategoryWrapper>
      <Addcategform onSubmit={onSubmit}>
        <FormEleWrapper>
          <TextField
            id="outlined-basic"
            size='small'
            name='name'
            onChange={(event) => onChangeAddBrandMaster(event)}
            label="Enter New Brand"
            value={addBrandMasterData?.name || ""}
            variant="outlined"
            sx={{backgroundColor:"white", width:"200px", height:"40px"}}
          />
          <Autocomplete
            multiple
            id="applicable-category-selector"
            size='small'
            options={assetmasters ? Object.values(assetmasters).map(x => x.Category).filter(Boolean).sort() : []}
            value={addBrandMasterData?.applicableCategory || []}
            onChange={(event, newValue) => onChangeAddBrandMaster(event, newValue, "applicableCategory")}
            disableCloseOnSelect
            getOptionLabel={(option) => option || ""}
            renderOption={(props, option, { selected }) => (
              <li {...props} style={{ fontSize: '1rem' }}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 0, marginLeft: -8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            sx={{ width: 250, marginLeft: "20px", backgroundColor: "white" }}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Select Applicable Categories" 
                sx={{ background: "white", width: "100%" }} 
              />
            )}
          />
        <SubmitButton type='submit'>Submit</SubmitButton>
        </FormEleWrapper>        
      </Addcategform>
      <Button2Div>
          <ExcelDownload data={downloadData} filename={"brandMaster"} sheetName={"sheet1"}/>
        </Button2Div> 
    </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead>
        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}}align="left">Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"25%"}}} align="left">Brand Id</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"35%"}}} align="left">Applicable Categories</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"25%"}}} align="left">Edit</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
              
               <BrandMasterEditable row={row} k={key} editFormData={editFormData} 
                handleCancelClick={handleCancelClick} page={page} rowsPerPage={rowsPerPage} editCategory={editCategory} onChangeEditBrand={onChangeEditBrand} assetmasters={assetmasters} SubmitButton ={SubmitButton} 
               />

                :<BrandMasterReadOnly row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} page={page} rowsPerPage={rowsPerPage} tableFontSize={tableFontSize} SubmitButton ={SubmitButton}              
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={4} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={4}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>

    <form onSubmit={onBulkSubmit}>
      <HeadingWrap>
        <Span>Upload Bulk Brands</Span>
      </HeadingWrap>

      <BulkWrapper>
        <ExcelDownload data={templateData} filename="brand_upload_template" sheetName="Template" button={true} />
        <InputFile type="file" onChange={handleChangeBrand} ref={inputFile} />
        <CustomFileUploadButton htmlFor="file-upload" onClick={handleButtonClick}>
          Upload File
        </CustomFileUploadButton>
        {file && (
          <>
            <span>{fileName}</span>
            <SelectFileReset type='button' onClick={() => deleteSelectFile()} >&times;</SelectFileReset>
            <Popup trigger={<SubmitButton type='button'>View File</SubmitButton>} position="right center" modal nested>
              <PopupTable props={file}/>
            </Popup>
            {finalFile.length > 0 && (
              <span style={{ marginLeft: '10px', color: 'green', fontWeight: 'bold' }}>
                {finalFile.length} brands ready for upload
              </span>
            )}
          </>
        )}
        <SubmitButton type='submit' disabled={!finalFile || finalFile.length === 0}>Submit</SubmitButton>
      </BulkWrapper>
    </form>
    </Displaydiv1>
    </>
  );
}